import React, { useEffect } from 'react';
import { Brain, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AdminFeaturesSection from '../components/AdminFeaturesSection';
import AdminTestimonialsSection from '../components/AdminTestimonialsSection';
import AuthClient from '../data/api/AuthClient';
import { ThemeSwitcher } from '../../../shared/components/ThemeSwitcher/ThemeSwitcher';
import '../styles/LoginStyle.css';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRegion = async () => {
      try {
        // Remove localStorage.clear() as it wipes out theme preferences
        const response = await AuthClient.getRegion();
        if (response?.region) {
          localStorage.setItem('iqadmin_region', response.region);
        }
      } catch (error) {
        console.error('Failed to fetch region:', error);
      }
    };
    fetchRegion();
  }, []);

  return (
    <div
      className="landing-page-wrapper"
      style={{
        overflowY: 'auto',
        height: '100vh',
        background: 'linear-gradient(-45deg, var(--bg-subtle), color-mix(in srgb, var(--iq-landing-primary) 15%, white), color-mix(in srgb, var(--iq-gradient-mid) 15%, white), color-mix(in srgb, var(--iq-gradient-end) 15%, white))',
        backgroundSize: '400% 400%',
        animation: 'admin-gradient-bg 15s ease infinite'
      }}
    >
      <style>
        {`
          @keyframes admin-gradient-bg {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
      {/* ═══ TOP NAVBAR ═══ */}
      <header className="lp-navbar" style={{ background: 'rgba(255, 255, 255, 0.5)', borderBottom: '1px solid rgba(255, 255, 255, 0.5)', backdropFilter: 'blur(20px)' }}>
        <div className="lp-navbar-inner">
          <div className="lp-navbar-brand">
            {/* <img src="/logo.png" alt="Logo" style={{ height: '32px', objectFit: 'contain' }} /> */}
            <img src="/logo_login_name.png" alt="Brand Name" style={{ height: '45px', objectFit: 'contain' }} />
          </div>

          <nav className="lp-navbar-links">
            <a href="#admin-features" className="lp-navbar-link" style={{ color: '#334155' }}>Features</a>
            <a href="#testimonials" className="lp-navbar-link" style={{ color: '#334155' }}>Testimonials</a>
          </nav>

          <div className="lp-navbar-actions">
            <div style={{ marginRight: '16px' }}>
              <ThemeSwitcher />
            </div>
            <button
              className="lp-navbar-btn-outline"
              style={{ color: 'var(--iq-landing-primary)', borderColor: 'var(--iq-landing-primary)', background: 'rgba(255,255,255,0.7)' }}
              onClick={() => navigate('/login')}
            >
              Login
            </button>
            <button
              className="lp-navbar-btn"
              style={{ background: 'var(--iq-landing-primary)', color: '#ffffff', boxShadow: 'var(--iq-landing-shadow)' }}
              onClick={() => navigate('/register')}
            >
              <span>Get Started</span>
              <ArrowRight size={14} />
            </button>
          </div>
        </div>
      </header>

      <div style={{ paddingTop: '80px' }}>
        <AdminFeaturesSection />
      </div>
      <AdminTestimonialsSection />
    </div>
  );
};

export default LandingPage;
